





















import { defineComponent, useRouter } from '@nuxtjs/composition-api';
import useAppRoute from '~/compositions/useAppRoute';
export default defineComponent({
  beforeRouteEnter(to, from, next) {
    next();
    // next((component) => {
    //   component.obj = objectData; // mountedの後に実行される
    // });
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    defaultBackUrl: {
      type: String,
      required: false,
      default: '',
    },
    forceBackUrl: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props) {
    const { URLs, redirect } = useAppRoute();
    const router = useRouter();

    /**
     * ページ移動のメソッド、特に何も指定しなければ、一つ前の画面に戻る。
     * window.historyが1以下の場合、Titlebarに設定したdefaultのurlに遷移する。
     * (window.historyが0の場合を確認出来なかったので、1以下という条件にしてます)
     * 指定したURLがある場合、指定したURLに遷移する
     */
    const page_move = () => {
      if (window.history.length <= 1) {
        redirect(props.defaultBackUrl);
      } else if (props.forceBackUrl) {
        redirect(props.forceBackUrl);
      } else {
        router.back();
      }
    };
    return {
      props,
      page_move,
    };
  },
});
